import { ApiConfig } from 'auxilium-connect';
import { LanguageDef } from 'src/lang';

export interface EnvironmentConfig {
  production: boolean;
  api?: ApiConfig;
  version: string;
  language?: keyof LanguageDef;
  socket?: string;
  stripeApi?: string;
  sliceMap?: { [sliceId: number]: string };
}

export const version = require('../../package.json').version as string;
